module.exports = __webpack_public_path__ + "img/gift_bg.e0fcd748.png";